import * as Common from "./common";

let pagination: IPagination;

let $backURL: JQuery;

export interface IInsertion {
    id: number;
    agencyId: number;
    url: string;
}

export interface IPagination {
    count: number;
    pageSize: number;
    backURL: string;
    pages: Record<number, Array<IInsertion>>;
    fromListing: boolean;
    fromMap: boolean;
    searchBean: any;
    direct: boolean;
    // Andrea M: head è l'elemento in testa, in tutti questi casi in cui non so la sua posizione
    head: number;
}

//TODO: da riportare questa componente in vanilla JS!
export function create(count: number, pageSize: number, currentPage: number, page: Array<IInsertion>, searchBean: any, backURL: string): void {

    const pagination = {
        count: count,
        pageSize: pageSize,
        backURL: backURL,
        pages: {[currentPage]: page},
        fromListing: true,
        direct: false,
        searchBean: searchBean
    } as IPagination;

    localStorage.setItem("pagination", JSON.stringify(pagination));
}

export function getPagination(): Promise<IPagination> {

    let fromMap: boolean;

    //Matteo C.: fix per quando si arriva dall'area pro, Chrome non permette di usare l'opener se si arriva da un dominio diverso
    try {
        fromMap = window.opener && window.opener.location.hash === "#map"
    } catch {
        fromMap = false;
    }

    const promises = [
        // Andrea M: da listato / mappa, ho già l'oggetto pagination
        (): Promise<IPagination | null> => new Promise((resolve: (pag: IPagination | null) => void) => {
            const obj = localStorage.getItem("pagination");

            if (!obj)
                resolve(null);
            else {
                const pagination = JSON.parse(obj) as IPagination;

                resolve(pagination);
            }
        }),
        // Andrea M: accesso diretto, devo chiamare la pagination direct
        (): Promise<IPagination | null> => new Promise((resolve: (pagination: IPagination | null) => void) => {

            const realEstate = Common.getRealEstateBean();

            if (!realEstate) {
                resolve(null);
                return;
            }

            const searchBean = buildSearchBeanFromRealEstate(realEstate);

            $.ajax({
                type: "POST",
                url: "/rest/realEstate/previousNextRealEstateDirect",
                async: false,
                headers: {
                    baseURL: window["_baseURL"]
                },
                data: JSON.stringify(searchBean),
                contentType: "application/json",
                crossDomain: true,
                success: (pagination: IPagination) => {

                    if (!pagination) {
                        resolve(null)
                        return;
                    }

                    pagination.direct = true;

                    resolve(pagination);
                },
                error: () => resolve(null)
            });
        })
    ];

    return new Promise<IPagination>((resolve, reject) => {
        // Andrea M: eseguo le promise in ordine per ottenere l'oggetto pagination
        promises.reduce((acc: Promise<unknown>, fn: () => void) => {
            return acc.then((data: any) => {
                return data ? data : fn();
            });
        }, Promise.resolve(null)).then((pagination: IPagination) => {

            if (!pagination) {
                reject("No pagination object found");
                return;
            }

            pagination.fromMap = fromMap;

            // Andrea M: controllo se l'immobile corrente è già nelle pagine o è in testa, se non c'è lo metto in testa
            if (!pagination.head && pagination?.pages) {

                const found = Object.keys(pagination.pages)?.some(key => {
                    const page = pagination.pages[parseInt(key)];
                    return page?.some((re: IInsertion) => re.id === window["_referenceId"]);
                });

                if (!found) {
                    pagination.head = window["_referenceId"];

                    pagination.pages[1]?.unshift({
                        id: window["_referenceId"],
                        url: window["_canonicalURL"]
                    } as IInsertion);

                }
            }

            localStorage.setItem("pagination", JSON.stringify(pagination));
            resolve(pagination);
        });
    });
}

export function writePagination(pagination: IPagination): void {
    localStorage.setItem("pagination", JSON.stringify(pagination));
}

export function init(): Promise<unknown> {

    $backURL = $(".backURL");

    return new Promise((resolve: (...args: Array<unknown>) => void) => {

        getPagination().then((data: IPagination) => {

            if (!data) {
                hidePagination();
                return;
            }

            pagination = data;

            let found = false;

            const pages = pagination.pages ?? {};

            Object.keys(pages)?.some((key: string) => {

                const pageNumber = parseInt(key);
                const page = pages[pageNumber] ?? [];
                if (page.length > 1)
                    page?.some((re: IInsertion, index: number) => {

                        if (re.id !== window["_referenceId"])
                            return false;

                        found = true;

                        Promise.all([
                            new Promise((resolve: (str: string) => void) => getPrevURL(index, pageNumber).then((data: string) => resolve(data))),
                            new Promise((resolve: (str: string) => void) => getNextURL(index, pageNumber).then((data: string) => resolve(data))),
                        ]).then(([prevURL, nextURL]: any) => {
                            draw(index, pageNumber, pagination.count, prevURL, nextURL, pagination.backURL);
                        });

                        return true;
                    });
            });

            if (!found)
                hidePagination();

            resolve();
        }).catch(() => {
            console.error("Cannot create pagination object");
            hidePagination();
        });
    });
}

function getPrevURL(index: number, pageNumber: number): Promise<string | undefined> {

    const page = pagination.pages[pageNumber];

    return new Promise((resolve: (str?: string) => void) => {

        if (index > 0)
            resolve(page[index - 1].url);
        else if (pagination.pages[pageNumber - 1])
            resolve(pagination.pages[pageNumber - 1][pagination.pages[pageNumber - 1].length - 1].url);
        else if (pageNumber !== 1 && pagination.searchBean) {
            getPage(pageNumber - 1, pagination.searchBean).then(() => {
                resolve(pagination.pages[pageNumber - 1][pagination.pages[pageNumber - 1].length - 1].url);
            }).catch(() => {
                resolve();
            });
        } else resolve();
    });
}

function getNextURL(index: number, pageNumber: number): Promise<string | undefined> {

    const page = pagination.pages[pageNumber];

    return new Promise((resolve: (str?: string) => void) => {

        if (index < page.length - 1)
            resolve(page[index + 1].url);
        else if (pagination.pages[pageNumber + 1])
            resolve(pagination.pages[pageNumber + 1][0].url);
        else if (pagination.searchBean) {
            getPage(pageNumber + 1, pagination.searchBean).then(() => {
                resolve(pagination.pages[pageNumber + 1][0].url);
            }).catch(() => {
                resolve()
            });
        } else resolve();
    });
}

function hidePagination(): void {
    $("#pagination").css("visibility", "hidden");
}

function draw(index: number, pageNumber: number, count: number, prevURL: string | unknown, nextURL: string | unknown, backURL: string): void {

    let position;
    // Andrea M: se non è paginazione diretta la posizione è semplicemente il numero di pagina - 1 per
    // 20 + l'indice + 1 (perchè l'indice è 0-indexed).
    // Se invece è paginazione diretta devo sommare la lunghezza delle pagine precedenti a quella a
    // in cui sono, perchè la prima pagina è di 21 elementi (l'elemento direct è in testa) e può essere
    // presente una pagina di 19 elementi (la pagina che realmente contiene l'elemento direct)
    if (!pagination.head)
        position = (pageNumber - 1) * pagination.pageSize + index + 1;
    else
        position = Object.keys(pagination.pages)
            .filter((key: string) => parseInt(key) < pageNumber)
            .reduce((acc: number, page: string) => acc + pagination.pages[Number(page)].length, 0) + index + 1;

    backURL = Common.updateQueryStringParameter(backURL, "p", pageNumber > 1 ? pageNumber.toString() : "");

    const $position = $("#position");
    const $prevRE = $("#prevRE");
    const $nextRE = $("#nextRE");

    $backURL.attr("href", `${backURL}#${window["_referenceId"]}`);

    if (backURL.indexOf("preferiti") > -1)
        $backURL.find("span").text("Torna ai preferiti");

    if (backURL.indexOf("agenzie-immobiliari") > -1)
        $backURL.find("span").text("Torna all'agenzia");

    // convert in string only for the showing data
    const positionThousand = position.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    const countThousand = count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    $position.html(`<span class="font-weight-semibold">${positionThousand}</span>/${countThousand}`);

    if (prevURL)
        $prevRE.attr("href", String(prevURL));
    else
        $prevRE.remove();

    if (nextURL)
        $nextRE.attr("href", String(nextURL));
    else
        $nextRE.remove();
}

function getPage(pageNumber: number, searchBean: any): Promise<unknown> {

    return new Promise((resolve: (...args: Array<unknown>) => void, reject: (error: Error) => void) => {
        $.ajax({
            type: "POST",
            url: "/rest/realEstate/previousNextRealEstate",
            headers: {
                baseURL: window["_baseURL"],
                pageNumber: pageNumber.toString()
            },
            data: searchBean,
            contentType: "application/json",
            crossDomain: true,
            success: (page: Array<IInsertion>) => {

                if (!page) {
                    resolve();
                    return;
                }

                // Andrea M: se ho un immobile in testa e lo trovo nella pagina successiva lo tolgo dalla pagina
                if (pagination.head)
                    page = page.filter((re: IInsertion) => re.id !== pagination.head);

                pagination.pages[pageNumber] = page;
                localStorage.setItem("pagination", JSON.stringify(pagination));

                resolve();
            },
            error: (error: any) => {
                reject(error);
            }
        });
    });
}

export function find(pagination: IPagination, id: number): boolean {
    return Object.keys(pagination.pages).some(key => {
        // @ts-ignore
        return pagination.pages[key].some((item: IInsertion) => {
            return item.id === id
        })
    });
}

function buildSearchBeanFromRealEstate(realEstate: Record<string, any>): Record<string, any> | null {

    if (!realEstate)
        return {};

    return {
        id: realEstate.id,
        sale: realEstate.sale,
        rent: realEstate.rent,
        auctionType: realEstate.auction ? 1 : 0,
        macroTypologyId: realEstate.macroTypologyID,
        cityId: realEstate.cityID,
        typologyId: realEstate.typologyType,
        localityIdList: realEstate.localityID ? [realEstate.localityID] : undefined,
        zoneIdList: realEstate.zoneID ? [realEstate.zoneID] : undefined,
    }
}